module.exports = __webpack_public_path__ + "img/3.5e176776.svg";